import React, { FunctionComponent } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';

export type ListItem = { title: string; id: string; };

export type LocationListProps = {
  locations: ListItem[],
  selectedLocationId: string | null;
  handleSelect: (id: string) => void;
}

const LocationList: FunctionComponent<LocationListProps> = (props) => {
  const {
    selectedLocationId,
    locations,
    handleSelect,
  } = props;

  return (
    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      {locations.map(({ title, id }) => (
        <ListItem
          key={id}
          disablePadding
        >
          <ListItemButton role={undefined} onClick={() => handleSelect(id)} dense>
            <ListItemIcon>
              <Radio
                edge='start'
                checked={id === selectedLocationId}
                tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-labelledby': `checkbox-list-label-${id}` }}
              />
            </ListItemIcon>
            <ListItemText id={`checkbox-list-label-${id}`} primary={title} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default LocationList;
